import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DashboardsIcon = ({ color })=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                x: "2.32292",
                y: "3.23966",
                width: "15.3542",
                height: "13.5208",
                rx: "1.26042",
                stroke: color || "#676879",
                strokeWidth: "1.14583"
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: "1.75",
                y1: "6.67708",
                x2: "18.25",
                y2: "6.67708",
                stroke: color || "#676879",
                strokeWidth: "1.14583"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.2399 10C14.2399 9.68359 13.9834 9.42708 13.667 9.42708C13.3506 9.42708 13.0941 9.68359 13.0941 10L14.2399 10ZM13.0941 10L13.0941 16.4167L14.2399 16.4167L14.2399 10L13.0941 10Z",
                fill: color || "#676879"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.5729 10.9167C10.5729 10.6003 10.3164 10.3438 10 10.3438C9.68359 10.3438 9.42708 10.6003 9.42708 10.9167L10.5729 10.9167ZM9.42708 10.9167L9.42708 16.4167L10.5729 16.4167L10.5729 10.9167L9.42708 10.9167Z",
                fill: color || "#676879"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.90592 12.75C6.90592 12.4336 6.64942 12.1771 6.33301 12.1771C6.01659 12.1771 5.76009 12.4336 5.76009 12.75L6.90592 12.75ZM5.76009 12.75L5.76009 16.4167L6.90592 16.4167L6.90592 12.75L5.76009 12.75Z",
                fill: color || "#676879"
            })
        ]
    });
